import { useState, useContext, useEffect, useMemo } from "react";
import {
  Stack,
  Box,
  Paper,
  Typography,
  useTheme,
  Avatar,
  useMediaQuery,
  IconButton,
} from "@mui/material";
import BoxHeader from "../atoms/BoxHeader";
import Navbar from "./Navbar";
import { AuthContext } from "../../Auth/Context";
import useWexClient from "../../hooks/Clients/wexClient,";

//SELECTOR DE TIPO DE MAPAS Y CHAT DE CABINA
import MapsReports from "../molecules/MapsReports";
import MapsReports_ForAdmin from "../molecules/MapsReports_ForAdmin";
//MAPAS
import ChekInMaps from "../../views/OptionDashboard/MapsType/ChekInMaps";
import RoutesMaps from "../../views/OptionDashboard/MapsType/RoutesMaps";
import RealTimeMaps from "../../views/OptionDashboard/MapsType/RealTimeMaps";
import HeatMap from "../../views/OptionDashboard/MapsType/heatmap";

import { GoSidebarCollapse } from "react-icons/go";
import { GoSidebarExpand } from "react-icons/go";

import ViewSidebarIcon from "@mui/icons-material/ViewSidebar";

import {
  Info as InfoIcon,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";

function OpcionReportes() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const { payload } = useContext(AuthContext);

  const isAdmin = useMemo(
    () => payload?.profile.class === "_ADMIN_",
    [payload],
  );
  const { getServices } = useWexClient();

  // Estados de Negocio
  const [services, setServices] = useState([]);
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [typeReport, setTypeReport] = useState("1");
  const [users, setUsers] = useState([]);

  // Filtros y Agentes
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [selectedList, setSelectedList] = useState(null);
  const [nameAgent, setNameAgent] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  //permisos

  const [dataService, setDataService] = useState(null);
  const permissions = dataService?.permissions;
  const [incidentCreatedMeta, setIncidentCreatedMeta] = useState(null); // notifica cuando se crea una incidencia desde el mapa
  const [mapIncidentLocation, setMapIncidentLocation] = useState(null);

  // Carga inicial de servicios
  useEffect(() => {
    if (!payload?._id) return;

    const fetchServices = async () => {
      try {
        const data = await getServices(payload._id);

        const formatservice = (data) => {
          if (!Array.isArray(data) || data.lenght === 0) {
            return null;
          }
          return {
            ...data[0],
            permissions: data[0]?.permissions || {},
          };
        };
        const dataServiceformmated = formatservice(data);
        //console.log(dataServiceformmated);
        setDataService(dataServiceformmated);

        const mappedServices = data.map((s) => ({
          id: s._id,
          name: s.name,
          avatar: s._config?.avatarClient,
        }));

        setServices(mappedServices);

        if (mappedServices.length > 0) {
          const firstId = mappedServices[0].id;
          setSelectedServiceId(firstId);
          sessionStorage.setItem("SelectedOption", firstId);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, [payload]);

  // 🔵 Inicializar selectedRegionId para Real-Time Maps
  useEffect(() => {
    if (typeReport === "1" && payload?.regionIds) {
      setSelectedRegionId(payload.regionIds);
    } else if (typeReport !== "1") {
      setSelectedRegionId(null);
    }
  }, [typeReport, payload?.regionIds]);

  // Derivados
  const currentService = useMemo(
    () => services.find((s) => s.id === selectedServiceId) || {},
    [services, selectedServiceId],
  );

  const MapComponent = useMemo(() => {
    const components = {
      1: RealTimeMaps,
      2: RoutesMaps,
      3: ChekInMaps,
      4: HeatMap,
    };

    return components[typeReport] || null;
  }, [typeReport]);

  // Reenvía la creación de la incidencia a MapsReports para abrir el chat
  const handleIncidentCreated = (message, response, formBody) => {
    setIncidentCreatedMeta({ message, response, formBody });
    setTimeout(() => setIncidentCreatedMeta(null), 100);
  };

  const mapProps = useMemo(
    () => ({
      selectedAgent,
      users,
      startDate,
      endDate,
      setStartDate,
      setEndDate,
      nameAgent,
      typeReport,
      selectedList,
      userId: payload._id,
      selectedRegionId,
      incidentCreatedMeta,
      incidentLocation: mapIncidentLocation,
      onIncidentCreated: handleIncidentCreated,
      onIncidentLocationChange: setMapIncidentLocation,
      permissions: dataService?.permissions,
    }),
    [
      selectedAgent,
      users,
      startDate,
      endDate,
      nameAgent,
      typeReport,
      selectedList,
      payload._id,
      selectedRegionId,
      incidentCreatedMeta,
      mapIncidentLocation,
      dataService?.permissions,
    ],
  );

  // Estado para colapsar el panel lateral
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  return (
    <Stack
      sx={{
        width: "100%",
        minHeight: "100vh",
        bgcolor: "background.paper",
        background: "linear-gradient(45deg, #7F8BFF, #55CEFF)",
        overflow: "hidden",
      }}
    >
      <Navbar forceWhiteBackground />
      <Stack
        direction={isMobile ? "column" : "row"}
        sx={{ flex: 1, height: "calc(100vh - 64px)", position: "relative" }}
      >
        {/* BOTÓN DE COLAPSO (Escritorio) */}
        {!isMobile && (
          <IconButton
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            sx={{
              position: "absolute",
              left: isSidebarOpen ? "520px" : "25px", // Ajustado para que no se corte al estar cerrado
              top: "10%",
              transform: "translate(-50%, -50%)",
              zIndex: 1300,
              bgcolor: "#9a2edb",
              color: "white",
              boxShadow: 3,
              transition: "left 0.3s ease-in-out",
              "&:hover": {
                bgcolor: "linear-gradient(45deg, #7F8BFF, #55CEFF)",
              },
            }}
          >
            {isSidebarOpen ? <GoSidebarExpand /> : <GoSidebarCollapse />}
          </IconButton>
        )}

        {/* PANEL IZQUIERDO */}
        <BoxHeader
          sx={{
            width: isMobile ? "100%" : isSidebarOpen ? "500px" : "0",
            p: isMobile ? 2 : isSidebarOpen ? 4 : 0,
            overflowY: "auto",
            overflowX: "hidden",
            mt: isMobile ? 10 : 0,
            background: "linear-gradient(45deg, #7F8BFF, #55CEFF)",
            transition: "all 0.3s ease-in-out",
            opacity: isSidebarOpen || isMobile ? 1 : 0,
            whiteSpace: "nowrap",
          }}
        >
          <Stack
            spacing={isMobile ? 3 : 4}
            sx={{
              mt: isMobile ? 0 : 8,
              minWidth: isMobile ? "auto" : "386px", // Evita que el contenido se amontone al cerrar
            }}
          >
            {/* HEADER */}
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar
                src={currentService.avatar}
                sx={{
                  width: isMobile ? 60 : 100,
                  height: isMobile ? 60 : 100,
                  border: "3px solid white",
                }}
              />
              <Typography
                variant={isMobile ? "h5" : "h4"}
                color="white"
                fontWeight="bold"
                sx={{
                  whiteSpace: "normal", // Permite saltos de línea
                  wordBreak: "break-word", // Rompe palabras largas si es necesario
                  lineHeight: 1.2,
                  display: "-webkit-box",
                  WebkitLineClamp: 2, // Limita a 2 líneas (opcional, puedes quitarlo si quieres todas las líneas)
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {currentService.name || "Cargando..."}
              </Typography>
            </Stack>

            {/* FILTROS */}
            {isAdmin ? (
              <MapsReports_ForAdmin
                {...mapProps}
                setSelectedAgent={setSelectedAgent}
                setSelectedList={setSelectedList}
                setTypeReport={setTypeReport}
                setServiceProp={() => {}}
                setUsers={setUsers}
                setNameAgent={setNameAgent}
                setSelectedRegionId={setSelectedRegionId}
                permissions={dataService?.permissions}
              />
            ) : (
              <MapsReports
                {...mapProps}
                setSelectedAgent={setSelectedAgent}
                setSelectedList={setSelectedList}
                setTypeReport={setTypeReport}
                setServiceProp={() => {}}
                setUsers={setUsers}
                setNameAgent={setNameAgent}
                setSelectedRegionId={setSelectedRegionId}
                permissions={dataService?.permissions}
              />
            )}

            {/* NOTA */}
            {typeReport !== "1" && (
              <Paper
                elevation={4}
                sx={{
                  p: 2,
                  bgcolor: "rgba(255, 255, 255, 0.2)",
                  backdropFilter: "blur(10px)",
                  color: "white",
                  borderLeft: "6px solid",
                  borderColor: "primary.dark",
                }}
              >
                <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                  <InfoIcon />
                  <Typography variant="subtitle1" fontWeight="bold">
                    Nota:
                  </Typography>
                </Stack>
                <Typography variant="body2">
                  Cada marcador en el mapa se identifica con las dos primeras
                  iniciales del agente.
                </Typography>
              </Paper>
            )}
          </Stack>
        </BoxHeader>

        {/* MAPA */}
        <Box
          sx={{
            flex: 1,
            height: isMobile ? "60vh" : "100%",
            borderRadius: isMobile ? 2 : 0,
            overflow: "hidden",
            boxShadow: isMobile ? 3 : 0,
            m: isMobile ? 2 : 0,
            transition: "all 0.3s ease-in-out",
          }}
        >
          {MapComponent && <MapComponent {...mapProps} />}
        </Box>
      </Stack>
    </Stack>
  );
}

export default OpcionReportes;
